<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-form :inline="true" :model="dataForm">
            <el-form-item>
                <el-select v-model="dataForm.agentId" filterable remote clearable :remote-method="searchAgents" :loading="agentLoading" placeholder="请输入代理用户名" style="width: 260px;">
                    <el-option v-for="agent in agentOptions" :key="agent.id" :label="agentLabel(agent)" :value="agent.id"/>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-select v-model="dataForm.status" placeholder="状态" clearable>
                    <el-option label="处理中" :value="0"/>
                    <el-option label="已完成" :value="1"/>
                    <el-option label="失败" :value="2"/>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="search">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="dataList" border>
            <el-table-column prop="recordNo" label="流水号" width="190"/>
            <el-table-column prop="applyNo" label="申请单号" width="190"/>
            <el-table-column prop="agent_username" label="代理用户名"/>
            <el-table-column prop="member_code" label="代理账号"/>
            <el-table-column prop="amount" label="申请金额"/>
            <el-table-column prop="actualAmount" label="实际金额"/>
            <el-table-column label="收款方式"><template slot-scope="scope">{{ payTypeText(scope.row.payType) }}</template>
            </el-table-column><el-table-column prop="status" label="状态"/>
            <el-table-column prop="finishTime" label="完成时间" width="180"/>
            <el-table-column prop="createTime" label="创建时间" width="180"/>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="text" @click="detail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination :current-page="page" :page-size="limit" :total="total" :page-sizes="[10,20,50,100]" layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChange" @current-change="currentChange"/>
            
            <el-dialog title="提现流水详情" :visible.sync="visible" width="600px">
                <el-descriptions v-if="record" :column="2" border><el-descriptions-item v-for="(v,k) in record" :key="k" :label="labels[k] || k">{{ v }}</el-descriptions-item></el-descriptions>
            </el-dialog>
    </el-card>
</template>
<script>import agentPage from '@/mixins/agent-page'; export default { mixins: [agentPage], data () { return { pageUrl: '/agent-withdraw-record/page', dataForm: { agentId: '', status: '' }, visible: false, record: null, labels: { id: 'ID', recordNo: '流水号', applyNo: '申请单号', agentId: '代理ID', amount: '金额', actualAmount: '实际金额', payType: '收款方式', receiptId: '收款账号ID', receiptSnapshot: '收款信息快照', status: '状态', finishTime: '完成时间', applyIp: '申请IP', remark: '备注', createTime: '创建时间', updateTime: '更新时间' } } }, methods: { detail (row) { this.$http.get(`/agent-withdraw-record/${row.id}`).then(({ data }) => { if (data.code !== 0) return this.$message.error(data.msg); this.record = data.data; this.visible = true }) } } }</script>
